/*
  Golfkuponger shared header navigation behavior.
  Keeps the Shopify-native header markup/overflow/drawer behavior intact and
  only normalizes the displayed Golfbanor label to "Alla klubbar".
*/
(() => {
  const renameGolfbanor = () => {
    document.querySelectorAll('#header-group a[href*="/pages/golfbanor"]').forEach((link) => {
      const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue && node.nodeValue.trim().toLowerCase() === 'golfbanor') {
          node.nodeValue = node.nodeValue.replace(/golfbanor/i, 'Alla klubbar');
        }
      }
    });
  };

  const init = () => {
    renameGolfbanor();
    const header = document.querySelector('#header-group');
    if (!header) return;

    const observer = new MutationObserver(renameGolfbanor);
    observer.observe(header, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 4000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
